import { render, staticRenderFns } from "./PropUserFrequency.vue?vue&type=template&id=5ebcf7ba&"
import script from "./PropUserFrequency.vue?vue&type=script&lang=js&"
export * from "./PropUserFrequency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports